<template>
    <tr :class="checkUnread" @click="openContactPage()">
      <td class="d-none d-sm-table-cell text-left">
        <span class="font-24">{{ contact.company.name }}</span>
        <br /> {{ contact.sender }}
      </td>
      <td class="d-none d-sm-table-cell text-left">{{ contact.subject }}</td>
      <td class="d-none d-sm-table-cell text-center">{{ formatDate }}</td>
      <td
        class="d-none d-sm-table-cell text-center"
        :class="checkResponseClass"
      >
        {{ userResponse }}
      </td>
      <td class="d-flex d-sm-none flex-row justify-content-between pb-0">
        <div class="w-65 font-16">{{ contact.company.name }}</div>
        <div>{{ formatDate}}</div>
      </td>
      <td class="d-flex d-sm-none flex-row justify-content-between">
        <div class="w-65">{{ contact.sender }}</div>
        <div :class="checkResponseClass" class="w-30 text-center">
          {{ userResponse }}
        </div>
      </td>
      <td class="d-flex d-sm-none flex-row justify-content-between">
        <div>{{ contact.subject }}</div>
      </td>
    </tr>
  </template>
  
  <script>
import moment from 'moment';
  export default {
    props: {
      contact: {
        type: Object,
        required: true,
      },
    },
    computed: {
        formatDate(){
            return moment(this.contact.sent_date).format("YYYY[年]MM[月]DD[日]");
        },
        changePage(page){
            this.setPage(page);
        },
        checkUnread(){
            if(this.contact.is_read) {
                return 'read'
            } else {
                return 'unread'
            }
        },
        userResponse() {
            return this.contact.contact_type === 'その他通知' ? '(回答不要)' : this.contact.user_response || '未回答';
        },
        checkResponseClass() {
            return this.contact.contact_type === 'その他通知' ? '' : !this.contact.user_response ? 'text-unreplied' : '';
        },
    },
    methods: {
        openContactPage(){
            const id = this.contact._id;
            this.$router.push({
                name: 'contactDetails',
                params: { id },
            })
        },
    },
  };
  </script>
  
  <style scoped>

  .w-65 {
    width: 65%;
  }
  .w-30 {
    width: 30%;
  }
  .text-unreplied {
      color: #e6001b;
  }
  
  .font-24 {
      font-size: 22px;
  }
  
  .font-16 {
      font-size: 16px;
  }
  
  .font-22 {
      font-size: 22px;
  }
  
  
  .unread {
      cursor: pointer;
      font-weight: bold !important;
      background-color: #fff;
  }
  
  .read {
      cursor: pointer;
      background-color: #E6E6E6;
  }
  
  td {
      border-bottom: 1px solid #c4c4c4;
      padding: 8px;
      text-align: center;
      color: #2F2E41;
      font-size: 16px;
  }
  
  tr {
      text-align: center;
      border-bottom: 1px solid #c4c4c4;
  }
  
  .mobile-view {
      display: none;
  }
  
  
  @media(max-width: 550px) {
  
      >>>.profile-detail-block table td {
          padding-left: 8px !important;
          min-height: 0px;
      }
  
      .desktop-view{
          padding: 0px !important;
      }
  
      table thead {
          display: none !important;
      }
  
      table td {
          font-size: 12px !important;
      }
  
      table td {
          padding: 5px 8px 0px 8px;
          border: 0px;
          text-align: left;
      }
      .rg-title {
          font-size: 16px !important;
          padding-top: 10px;
          padding-left: 5px;
          font-weight: 700;
      }
      .mobile-view {
          display: block !important;
          padding: 10px;
      }
  
      /* .desktop-view {
          display: none !important;
      } */
  }
  
  
  </style>